import React from "react";
import { useTranslation } from "react-i18next";
import { useStyleSchema } from "@components/styleSchema/StyleSchemaHandler";
import { CheckCircle } from "@phosphor-icons/react";

interface RegistrationSuccessProps {
  onNavigateToAccount: () => void;
}

export const RegistrationSuccess: React.FC<RegistrationSuccessProps> = ({
  onNavigateToAccount,
}) => {
  const { t } = useTranslation();
  const { currentSchema } = useStyleSchema();
  const buttonColor = currentSchema.colors?.primary?.hex;

  return (
    <div className="flex flex-col items-center justify-center text-center animate-scaleIn">
      <div 
        className="w-16 h-16 rounded-full mb-4 flex items-center justify-center"
        style={{ backgroundColor: buttonColor }}
      >
        <CheckCircle size={32} weight="bold" className="text-white" />
      </div>
      
      <h2 className="text-2xl font-bold mb-2">
        {t("register.messages.formSuccess")}
      </h2>
      
      <button
        onClick={onNavigateToAccount}
        className="px-4 py-2 rounded text-center md:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
        style={{
          backgroundColor: buttonColor,
          color: "white",
        }}
      >
        {t("register.buttons.accountReady")}
      </button>
    </div>
  );
};